import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

import styles from "../InterviewPipeline.module.scss";
import {
  resetFilter,
  updateFilter,
  fetchPipeline,
  clearAllColumnFilters,
} from "../../../../redux-store/slices/pipelineSlice";

import { decryptedAdminID } from "../../../../utility";
import DateFilter from "../../../../components/Common/FilterComponent/DateFilter";

const ALL_OPTION = { id: "ALL", name: "All" };

const FilterPanel = ({
  adminList = [],
  onlyMe,
  setOnlyMe,
  onClose,
  applyFilter,
  resetDateFilter,
  setResetDateFilter
}) => {
  const dispatch = useDispatch();
  // console.log(adminList, "adminList");

  // ✅ NEW SELECTOR (IMPORTANT)
  const { currentType, pipelineByType } = useSelector(
    (state) => state.pipeline,
  );

  const filters = pipelineByType[currentType].filters;

  const adminDetails = useSelector((state) => state.adminDetails);
  const isSuperAdmin = adminDetails.roleID == 1;
  const isTeamLeader = localStorage.getItem("teamLeader") == "true";

  const adminID = Number(decryptedAdminID());

  const handleChange = (e) => {
    const { name, value } = e.target;

    dispatch(
      updateFilter({
        [name]: value || null,
      }),
    );
  };
const formattedAdminList = (adminList || []).map((item) => ({
  ...item,
  name: item.id === adminID ? "Self" : item.name,
}));

  const handleAdminChange = (event, value) => {
    let finalIds = [];

    if (!value) {
      finalIds = [];
    } else if (value.id === "ALL") {
      finalIds = adminList.map((a) => a.id);
    } else {
      finalIds = [value.id];
    }

    dispatch(updateFilter({ admin_ids: finalIds }));

    if (finalIds.length === 1 && finalIds[0] === adminID) {
      setOnlyMe(true);
    } else {
      setOnlyMe(false);
    }
  };

  // ✅ APPLY FILTER
  const handleApply = () => {
    dispatch(clearAllColumnFilters());
    applyFilter();
    onClose();
  };

  // ✅ CLEAR FILTER
const handleClear = () => {
  dispatch(resetFilter());

  let defaultAdminIds = [];

  if (isSuperAdmin) {
    defaultAdminIds = adminList.map((a) => a.id);
    setOnlyMe(false);
  } else if (isTeamLeader) {
    defaultAdminIds = [adminID];
    setOnlyMe(true);
  }else {
  defaultAdminIds = [adminID]; // ✅ NORMAL USER = SELF
  setOnlyMe(true);
}

  dispatch(updateFilter({ admin_ids: defaultAdminIds }));

  setResetDateFilter(true);

  dispatch(fetchPipeline({ offset: 0 }));
};

useEffect(() => {
  if (resetDateFilter) {
    const timer = setTimeout(() => {
      setResetDateFilter(false);
    }, 0);

    return () => clearTimeout(timer);
  }
}, [resetDateFilter]);

  return (
    <div className={styles.filterPanel}>
      <div className={styles.filterBody}>
        <div className={styles.row}>
          <TextField
            fullWidth
            label="Mobile Number"
            name="mobile_number"
            value={filters.mobile_number || ""}
            onChange={(e) => {
              const value = e.target.value;

              // ✅ Allow only numbers & max 10 digits
              if (/^\d{0,10}$/.test(value)) {
                handleChange(e);
              }
            }}
            inputProps={{
              maxLength: 10,
              inputMode: "numeric", // mobile keyboard
              pattern: "[0-9]*",
            }}
          />

          <TextField
            fullWidth
            label="Candidate Name"
            name="first_name"
            value={filters.first_name || ""}
            onChange={handleChange}
          />
        </div>

        <TextField
          fullWidth
          label="Company Name"
          name="company_name"
          value={filters.company_name || ""}
          onChange={handleChange}
        />

        <div className="mt-2 mb-2">
          <b className="mb-2">Moved Date :</b>

          <div className="mt-2 mb-2">
           {/* <DateFilter
  resetTrigger={resetDateFilter}
  onChange={(dates) => {
    const payload = {
      date_from: dates.date_from || null,
      date_to: dates.date_to || null,
    };

    dispatch(updateFilter(payload));

    // ✅ IMPORTANT: trigger API
    dispatch(fetchPipeline({ ...payload, offset: 0 }));
  }}
/> */}
<DateFilter
  key={currentType}
  value={{
    date_from: filters.date_from,
    date_to: filters.date_to,
  }}
  resetTrigger={resetDateFilter}
  onChange={(dates) => {
    const payload = {
      date_from: dates.date_from || null,
      date_to: dates.date_to || null,
    };

    dispatch(updateFilter(payload));
    // dispatch(fetchPipeline({ ...payload, offset: 0 }));
  }}
/>
          </div>
        </div>

        {(isSuperAdmin || isTeamLeader) && (
          <Autocomplete
            options={[ALL_OPTION, ...formattedAdminList]}
            getOptionLabel={(option) => option.name || ""}
            value={
              (filters.admin_ids || []).length === adminList.length
                ? ALL_OPTION
                : formattedAdminList.find((item) =>
                    (filters.admin_ids || []).includes(item.id),
                  ) || null
            }
            defaultValue={ALL_OPTION}
            onChange={handleAdminChange}
            renderInput={(params) => (
              <TextField {...params} label="Admin Name" />
            )}
          />
        )}
      </div>

      <div className={styles.filterFooter}>
        <button className={styles.ClearButton} onClick={handleClear}>
          Clear
        </button>

        <button className={styles.ApplyButton} onClick={handleApply}>
          Apply Filter
        </button>
      </div>
    </div>
  );
};

export default FilterPanel;
